import React, { FC } from 'react';
import round from 'lodash.round';
import {
  CardInfo,
  CardInfoItem,
  CardInfoValueType,
  FlexItem,
  H3,
} from '@erecruit/ui-kit';
import { Resources, AppPermissions } from '@erecruit/types';
import { Intl } from '@erecruit/core';
import { Authorize } from '@erecruit/modules';

import SectionContextMenu from '../SectionContextMenu';
import { BaseSectionProps } from '../../types';
import { currencySymbol } from '../../../AddNewPositionWizard/components/BillingStep/helpers';

const { FormattedMessage } = Intl;

interface BillingSectionProps
  extends BaseSectionProps<Resources.PositionBilling>,
    Intl.InjectedIntlProps {
  isMyOwn: boolean;
}

const BillingSection: FC<BillingSectionProps> = props => {
  const { data, expanded, onEdit, intl, isMyOwn } = props;
  const { targetBillRate, estimatedSpend } = data;

  return (
    <FlexItem>
      <CardInfo
        showDetails={expanded}
        title={
          <H3 align="center">
            <FormattedMessage
              id={messageIds.vms.positionRecord.billing.title}
            />
          </H3>
        }
        extra={
          <Authorize
            permission={`(${AppPermissions.EditPositions} | (${AppPermissions.EditMyOwnPositions} & ${isMyOwn})) & ${AppPermissions.EditPositionBilling}`}
          >
            <SectionContextMenu section="billing" onEdit={onEdit} />
          </Authorize>
        }
      >
        <CardInfoItem
          type={CardInfoValueType.Text}
          value={
            targetBillRate
              ? `${currencySymbol(intl)}${round(targetBillRate, 2)}`
              : '-'
          }
          label={
            <FormattedMessage
              id={messageIds.vms.positionRecord.billing.targetBillRate}
            />
          }
        />
        <CardInfoItem
          label={
            <FormattedMessage
              id={messageIds.vms.positionRecord.billing.estimatedSpend}
            />
          }
          type={CardInfoValueType.Text}
          value={
            estimatedSpend
              ? `${currencySymbol(intl)}${round(estimatedSpend, 2)}`
              : '-'
          }
        />
      </CardInfo>
    </FlexItem>
  );
};

export default Intl.injectIntl(BillingSection);
